// Keys for localStorage
export const QUIZ_STATE_KEY = 'quizState';
export const USER_DATA_KEY = 'userData';

// Save quiz state to localStorage
export const saveQuizState = (state: any): void => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(QUIZ_STATE_KEY, serializedState);
  } catch (error) {
    console.error('Could not save quiz state to localStorage:', error);
  }
};

// Load quiz state from localStorage
export const loadQuizState = (): any | undefined => {
  try {
    const serializedState = localStorage.getItem(QUIZ_STATE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.error('Could not load quiz state from localStorage:', error);
    return undefined;
  }
};

// Save user data to localStorage
export const saveUserData = (userData: any): void => {
  try {
    const serializedData = JSON.stringify(userData);
    localStorage.setItem(USER_DATA_KEY, serializedData);
  } catch (error) {
    console.error('Could not save user data to localStorage:', error);
  }
};

// Load user data from localStorage
export const loadUserData = (): any | null => {
  try {
    const serializedData = localStorage.getItem(USER_DATA_KEY);
    if (serializedData === null) {
      return null;
    }
    return JSON.parse(serializedData);
  } catch (error) {
    console.error('Could not load user data from localStorage:', error);
    return null;
  }
};

// For backward compatibility
export const loadUserEmail = (): string | null => {
  const userData = loadUserData();
  if (userData && userData.email) {
    return userData.email;
  }
  // Try the old key for backward compatibility
  try {
    return localStorage.getItem('userEmail');
  } catch (error) {
    console.error('Could not load user email from localStorage:', error);
    return null;
  }
};

// Clear all quiz data from localStorage
export const clearQuizData = (): void => {
  try {
    localStorage.removeItem(QUIZ_STATE_KEY);
    localStorage.removeItem(USER_DATA_KEY);
    // Remove old key for backward compatibility
    localStorage.removeItem('userEmail');
    // Keep UTM data when clearing quiz data - it should persist across quiz sessions
    // localStorage.removeItem('utmData'); // Commented out intentionally
  } catch (error) {
    console.error('Could not clear quiz data from localStorage:', error);
  }
};
